var map = {
	"./customer.js": "f1b1",
	"./design.js": "b6c9",
	"./estore.js": "a24d",
	"./index.js": "2a74",
	"./medpadala.js": "ded1",
	"./merchant.js": "e6df",
	"./organization.js": "45b0",
	"./page.js": "c3b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d307";